<template>
    <div class="column">
        <h5 v-if="isExistingTitle" class="column__title">
            <slot name="title">
                {{ column.title }}
            </slot>
        </h5>

        <slot>
            <ul class="column__list">
                <li class="column__list-item" v-for="(item, index) in items" :key="index">
                    <component :is="getComponentName(item.type)" :item="item" />
                </li>
                <li v-if="column?.paymentDetails?.length" class="column__list-item column__list-item--images">
                    <img
                        v-for="(payment, index) in column.paymentDetails"
                        class="column__list-item-image"
                        :key="index"
                        :src="payment.image"
                        :alt="index"
                    />
                </li>
            </ul>
        </slot>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { columnStructure } from '@/themes/novaporta/components/widgets/Footer/types';

export default {
    name: 'Column',
    props: {
        column: VueTypes.oneOfType([columnStructure]).isRequired
    },
    components: {
        LinksList: () => import('./components/LinksList'),
        ContactsContent: () => import('./components/ContactsContent')
    },
    computed: {
        isExistingTitle() {
            return !!this.column?.title?.length;
        },
        items() {
            return this.column?.items || [];
        }
    },
    methods: {
        getComponentName(type) {
            return ['image', 'link', 'tagLink'].includes(type) ? 'LinksList' : 'ContactsContent';
        }
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
